import React from 'react'
import { Heading } from '../components/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBook,
    faTruck,
    faSyncAlt,
    faMoneyBillWaveAlt,
    faChartSimple,
} from '@fortawesome/free-solid-svg-icons';

// Placeholder metrics. Once the statistics backend is wired up, these values
// will come from the API instead of the em dash.
const STATS = [
    { key: 'catalog', icon: faBook, label: 'Títulos en catálogo', value: '—' },
    { key: 'delivery', icon: faTruck, label: 'Entregas activas', value: '—' },
    { key: 'conversions', icon: faSyncAlt, label: 'Conversiones en proceso', value: '—' },
    { key: 'sales', icon: faMoneyBillWaveAlt, label: 'Ventas del periodo', value: '—' },
];

export function Dashboard() {
    const title = 'Dashboard';

    return (
        <>
            <Heading title={title} />

            <div className="container">
                <div className="dashboard-stats">
                    {STATS.map((stat) => (
                        <div key={stat.key} className="dashboard-stat-card">
                            <div className="dashboard-stat-icon">
                                <FontAwesomeIcon icon={stat.icon} />
                            </div>
                            <div className="dashboard-stat-value">{stat.value}</div>
                            <div className="dashboard-stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>

                <div className="dashboard-placeholder">
                    <FontAwesomeIcon icon={faChartSimple} className="me-2" />
                    Estadísticas en camino: aquí verás el resumen de tu operación.
                </div>
            </div>
        </>
    )
}

export default Dashboard
